<div class="container">
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Add Customer"></aw-bread-crumb>
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }

  <aw-dialog
    [visible]="openClientInfoDialog"
    [formFieldsData]="formFieldsData"
    [dialogOptions]="dialogOptions"
    (primaryAction)="dialogCloseHandler()"
    ariaLabel="Customer Info"
  >
  </aw-dialog>

  <app-unsaved-changes-dialog></app-unsaved-changes-dialog>

  <aw-toast></aw-toast>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'New Customer'"
    [altColor]="false"
  >
  </aw-divider>


  <div class="form-container">
    <!-- Customer Name Field -->
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      [multiline]="true"
      title="Customer Name"
      [maxCharacters]="nameMaxLength"
      [allowedPattern]="namePattern"
      [patternMessage]="namePatternMessage"
      (textEntry)="onCustomerNameSelected($event)"
    ></app-aw-text-form>

    <!-- Customer Status Field -->
    <app-aw-dropdown-form
      class="input"
      [options]="statusOptions()"
      title="Status"
      (currentOption)="onCustomerStatusSelected($event)"
    ></app-aw-dropdown-form>
  </div>
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
